import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

class CoursesService {
  // Get all courses
  getCourses = async (params = {}) => {
    try {
      const response = await axiosApiClient.get("/courses", { params });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja kurseva");
    }
  };

  // Get course by ID
  getCourseById = async (id) => {
    try {
      const response = await axiosApiClient.get(`/courses/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja kursa");
    }
  };

  // Get user's courses
  getUserCourses = async () => {
    try {
      const response = await axiosApiClient.get("/courses/user/my-courses");
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja vaših kurseva");
    }
  };

  // Get featured courses for homepage
  getFeaturedCourses = async (limit = 3) => {
    try {
      const response = await axiosApiClient.get("/courses", {
        params: { featured: true, limit },
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Greška prilikom učitavanja istaknutih kurseva");
    }
  };

  // Download PDF script
  downloadPdfScript = async (courseId, scriptName) => {
    try {
      const response = await axiosApiClient.get(`/courses/${courseId}/download/${scriptName}`, {
        responseType: 'blob',
        withCredentials: true
      });
      
      // Create blob link to download file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', scriptName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (err) {
      throw handleError(err, "Greška prilikom preuzimanja PDF skripte");
    }
  };
}

const coursesService = new CoursesService();
export default coursesService;
